import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

// Matches this component's own scss `width: 20rem`, so callers positioning its
// containing popover can predict its footprint before it renders.
export const ADD_MODEL_MENU_WIDTH = 320;

@Component({
  selector: 'ocp-add-model-menu',
  templateUrl: './add-model-menu.component.html',
  styleUrl: './add-model-menu.component.scss',
  imports: [TranslatePipe, ThemedIconComponent],
})
export class AddModelMenuComponent {
  readonly modelSelected = output<void>();
  readonly ifcSelected = output<void>();

  protected onModelSelected(): void {
    this.modelSelected.emit();
  }

  protected onIfcSelected(): void {
    this.ifcSelected.emit();
  }
}
